import React, { useState, useEffect } from 'react';
import { useCart } from '../contexts/CartContext';
import dolibarrApi from '../services/dolibarrApi';

const Collection = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { addItem } = useCart();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const fetchedProducts = await dolibarrApi.getProducts();
        setProducts(fetchedProducts);
      } catch (err) {
        console.error('Error fetching products:', err);
        setError('Failed to load products');
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const openModal = (product) => {
    setSelectedProduct(product);
  };

  const closeModal = () => {
    setSelectedProduct(null);
  };

  const handleAddToCart = (product) => {
    addItem(product);
    closeModal();
  };

  const getStockStatus = (stock) => {
    if (stock <= 0) return { status: 'Out of Stock', className: 'stock-out-stock' };
    if (stock <= 5) return { status: 'Low Stock', className: 'stock-low-stock' };
    return { status: 'In Stock', className: 'stock-in-stock' };
  };

  if (loading) {
    return (
      <section id="collection" className="collection">
        <h2>THE COLLECTION</h2>
        <div className="loading">Loading products...</div>
      </section>
    );
  }

  if (error) {
    return (
      <section id="collection" className="collection">
        <h2>THE COLLECTION</h2>
        <div className="error">{error}</div>
      </section>
    );
  }

  return (
    <section id="collection" className="collection">
      <h2>THE COLLECTION</h2>
      <div className="collection-grid">
        {products.map((product) => (
          <div key={product.id} className="collection-item">
            <img src={product.image || '/placeholder-image.jpg'} alt={product.label} />
            <h3>{product.label}</h3>
            <div dangerouslySetInnerHTML={{ __html: product.description }} style={{ marginBottom: '1rem' }}></div>
            <button onClick={() => openModal(product)} className="btn-view">View Product</button>
          </div>
        ))}
      </div>

      {selectedProduct && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>&times;</button>
            <div className="modal-body">
              <img src={selectedProduct.image || '/placeholder-image.jpg'} alt={selectedProduct.label} className="modal-image" />
              <div className="modal-details">
                <h2>{selectedProduct.label}</h2>
                <div dangerouslySetInnerHTML={{ __html: selectedProduct.description }} style={{ marginBottom: '1rem' }}></div>
                <div className="stock-status" style={{ marginBottom: '1rem' }}>
                  <span className={getStockStatus(selectedProduct.stock_reel).className}>
                    {getStockStatus(selectedProduct.stock_reel).status}
                  </span>
                </div>
                <p style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#d4af37', marginBottom: '1rem' }}>
                  £{parseFloat(selectedProduct.price_ttc).toFixed(2)}
                </p>
                <button
                  className="btn"
                  onClick={() => handleAddToCart(selectedProduct)}
                  disabled={selectedProduct.stock_reel <= 0}
                >
                  Add to Cart
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Collection;
